export const dishes = [
    '5546', '5548', '3871', '5547', '5543', '3873', '3874', '3880', '3878', '3879', '3881',
];

export const periods = [
    '2026-11-02',
    '2026-11-09',
    '2026-11-16',
    '2026-11-23',
    '2026-11-30',
    '2026-12-07',
    '2026-12-14',
    '2026-12-21',
];
